<template>
     <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
                    <div class="blk1g">
						公告中心
                      <div @click="goBack" class="imgp"><van-icon name="arrow-left" /></div>
                    </div>
					<div class="pannelstn">
						<div v-if="count>0" class="pannels" >
							<div class="innerCell" @click="toDetail(item)" v-for="(item,index) in dataList" :key="index">
								<div class="syCell">
									<div class="cellsy">
										<div class="innerTitle">{{item.noticeTitle}}</div>
										<div class="innerSub" style="display:flex">
											<div class="sName" style="flex:1;">发布人：{{item.createBy}}</div>
											<div class="stime" style="flex:1">发布时间：{{item.createTime}}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="nData" v-else>
							<div>暂无数据</div>
						</div>
					</div>
					
					
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    export default{
		data(){
			return {
				dataList:[],
				count:0
			}
		},
		created(){
			this.getNotice()
		},
		mounted(){
			this.getNotice()
		},
		methods:{
			goBack(){
				this.$router.push('/index')
			},
			toDetail(item){
				this.$router.push({path:'/noticeDetail',query:{id:item.noticeId}})
			},
			getNotice(){
				let data={noticeType:1,noticeStatus:0}
			    this.$api.post('/app/notice/getNotice',data).then(res=>{
			           if(res.data.code=="0000"){
			                if(res.data.data){
								// this.count=res.data.data.count
								this.count=res.data.data.datalist.length
			                    let data=res.data.data.datalist;
			                    this.dataList=data
			                }
			           }
			        }
			    )
			},
		},
    }
</script>
<style scoped>
	.nData{
	    width:100%;
	    height:60px;
	    display:flex;
	    justify-content:center;
	    align-items:center;
	    font-size:16px;
		margin-top:100px;
	}
	.wrap{
	        position: absolute;
	            top: 0;
	            left:0;
	            /* z-index:1000; */
	            width:100%;
	            height:100%;
	            overflow: auto;
	            background:#e9eef2;
				overflow-x:hidden;
	    }
	    .wrap_inner{
	         min-height: 100%;
	         width:100%;
	    }
	    .wrap_main{
			position:absolute;
			width:100%;
			height:100%;
			box-sizing:border-box;
			    padding-bottom: 55px;
	    }
    .mainlist{
        width:100%;
        height:100%;
    }
	.blk1g{
	    position:relative;width: 100%;
		width: 375px;
		height: 44px;
		text-align: center;
		color: #fff;
		font-size: 18px;
		font-weight: 800;
		line-height: 44px;
		background: linear-gradient(48deg,#0080ff, #0080ff 89%);
	  }
	.blkps{
	   /* position:absolute;
	    top:48px;
	    right:52px;
	    width:90px;
	    height:90px; */
	}
	.blkrect{
	    width: 20px;
	    height: 2px;
	    background: #ffffff;
	}
	.txtku1{
	    margin:4px 0 10px 0;
	    font-size: 20px;
	    font-weight: 800;
	    text-align: left;
	    color: #ffffff;
	}
	.imgp{
	    position:absolute;
	    display:flex;
	    align-items:center;
	    justify-content:center;
	    top:10px;
	    left:14px;
	    width:10px;
	    height:14px;
	    color:#fff;
	    font-size:25px;
	}
   .bmk{
      position:relative;width: 100%;height: 28px;
       padding:20px 0;
       font-size: 20px;
       font-weight: 700;
       text-align: center;
       color: #101d36;
       line-height: 28px;
   }
   .pannelstn{
	   width:100%;
	   height:calc(100% - 50px);
	   overflow: auto;
   }
   .pannels{
	   width: 335px;
	   height:calc(100% - 8px);
	   /* min-height: 60%; */
	   margin:0 auto;
	   opacity: 1;
	   border-radius: 4px;
	   font-size:16px;
	   border-radius: 4px;
	   /* box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16); */
   }
   .innerCell{
	   width:335px;
	   background:#fff;
	   padding:15px 16px;
	   box-sizing:border-box;
	   height: 86px;
	   margin-top:8px;
	   border-radius: 4px;
	   border-left: 4px solid #0080ff;
	   box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16); 
   }
   .syCell{
	   width:100%;
	   height:100%;
   }
   .cellsy{
   	   width:100%;
   	   height:100%;
   	   
   }
   .innerSub{
	  font-size: 12px;
	  color: #666666;
	  line-height: 28px;
   }
   .innerTitle{
	   width:274px;
	   	overflow:hidden;
	   　　text-overflow:ellipsis;
	   　　white-space:nowrap;
	   font-size: 16px;
	   color:#333333;
	   line-height: 28px;
   }
   .sName{
	   	overflow:hidden;
	   　　text-overflow:ellipsis;
	   　　white-space:nowrap;
	   font-size:12px;
	   color: #666666;
   }
   .stime{
	   	overflow:hidden;
	   　　text-overflow:ellipsis;
	   　　white-space:nowrap;
	   font-size:12px;
	   color: #666666;
   }
</style>
